import MuiToggleButton, { type ToggleButtonProps } from "@mui/material/ToggleButton";
import MuiToggleButtonGroup, { type ToggleButtonGroupProps } from "@mui/material/ToggleButtonGroup";

export type { ToggleButtonProps, ToggleButtonGroupProps };

export function ToggleButton(props: ToggleButtonProps) {
  return <MuiToggleButton {...props} />;
}

export function ToggleButtonGroup(props: ToggleButtonGroupProps) {
  return <MuiToggleButtonGroup {...props} />;
}
